var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickFix2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.186,45.583L55,44.82v-9.64l-3.814-0.763c-0.408-1.406-0.968-2.759-1.671-4.038l2.157-3.235l-6.817-6.816l-3.235,2.157   c-1.277-0.703-2.631-1.263-4.037-1.671L36.82,17H27.18l-0.762,3.814c-1.395,0.405-2.737,0.958-4.004,1.652l-3.275-2.131   l-6.804,6.803l2.131,3.277c-0.688,1.256-1.237,2.585-1.641,3.965L9,35.189v9.621l3.825,0.81c0.403,1.38,0.953,2.709,1.641,3.965   l-2.131,3.277l6.804,6.803l3.275-2.131c1.256,0.687,2.585,1.237,3.965,1.641L27.189,63h9.621l0.811-3.825   c1.392-0.407,2.732-0.964,3.998-1.66l3.235,2.157l6.817-6.816l-2.157-3.235C50.218,48.342,50.777,46.988,51.186,45.583z    M49.098,52.601l-4.497,4.498l-2.909-1.939l-0.541,0.321c-1.442,0.854-3.001,1.502-4.633,1.925l-0.599,0.155L35.189,61h-6.379   l-0.729-3.44l-0.599-0.155c-1.618-0.419-3.164-1.059-4.596-1.902l-0.534-0.314l-2.946,1.916l-4.511-4.511l1.916-2.947l-0.314-0.534   c-0.843-1.431-1.482-2.977-1.901-4.595l-0.154-0.6L11,43.189v-6.379l3.441-0.729l0.154-0.6c0.419-1.618,1.059-3.164,1.901-4.595   l0.314-0.534l-1.916-2.947l4.511-4.511l2.946,1.916l0.534-0.314c1.443-0.851,3.004-1.494,4.639-1.913l0.609-0.156L28.82,19h6.359   l0.686,3.428l0.609,0.156c1.647,0.422,3.221,1.073,4.676,1.936l0.541,0.321l2.909-1.939l4.497,4.498l-1.938,2.909l0.32,0.541   c0.862,1.456,1.514,3.029,1.936,4.676l0.156,0.609L53,36.82v6.36l-3.429,0.686l-0.156,0.609c-0.422,1.647-1.073,3.22-1.936,4.676   l-0.32,0.541L49.098,52.601z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 31,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.6394 21.6155)",
    width: 2,
    x: 18.273,
    y: 26.272
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 13,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -31.6396 29.0714)",
    width: 2,
    x: 18.273,
    y: 51.728
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 31,
    y: 57
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -24.184 47.0708)",
    width: 2,
    x: 43.728,
    y: 51.728
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 49,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -6.1838 39.6149)",
    width: 2,
    x: 43.728,
    y: 26.272
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,27c-7.168,0-13,5.832-13,13s5.832,13,13,13s13-5.832,13-13S39.168,27,32,27z M32,51c-6.065,0-11-4.935-11-11   s4.935-11,11-11s11,4.935,11,11S38.065,51,32,51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,33c-3.859,0-7,3.14-7,7s3.141,7,7,7s7-3.14,7-7S35.859,33,32,33z M32,45c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5   S34.757,45,32,45z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 55,
    y: 53
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 55,
    y: 57
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 57,
    y: 55
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 53,
    y: 55
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 3,
    y: 55
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 3,
    y: 59
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 5,
    y: 57
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 1,
    y: 57
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 59,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 59,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 61,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 57,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 5,
    y: 23
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 5,
    y: 27
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 7,
    y: 25
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 3,
    y: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,19c2.999,0,5.812-1.519,7.475-4h29.051c1.663,2.481,4.476,4,7.475,4c2.064,0,4.011-0.689,5.628-1.992l0.372-0.3V13   h-4.382l-1.5-3l1.5-3H60V3.292l-0.372-0.3C58.011,1.689,56.064,1,54,1c-2.999,0-5.812,1.519-7.475,4H17.475   C15.812,2.519,12.999,1,10,1C7.936,1,5.989,1.689,4.372,2.992L4,3.292V7h4.382l1.5,3l-1.5,3H4v3.708l0.372,0.3   C5.989,18.311,7.936,19,10,19z M6,15h3.618l2.5-5l-2.5-5H6V4.268C7.179,3.437,8.552,3,10,3c2.484,0,4.805,1.342,6.056,3.501   L16.345,7h31.311l0.289-0.499C49.195,4.342,51.516,3,54,3c1.448,0,2.821,0.437,4,1.268V5h-3.618l-2.5,5l2.5,5H58v0.732   C56.821,16.563,55.448,17,54,17c-2.484,0-4.805-1.342-6.056-3.501L47.655,13H16.345l-0.289,0.499C14.805,15.658,12.484,17,10,17   c-1.448,0-2.821-0.437-4-1.268V15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickFix2);
export default __webpack_public_path__ + "static/media/quick-fix-2.50301bd181fad5a015e94a9515aede31.svg";
export { ForwardRef as ReactComponent };